import { hydrateWidgets } from '@utils';
import { Nav } from '../../widgets/Explore/DVWebNodeNav/Nav';
hydrateWidgets(Nav);
